module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-profile/master-register-profile.component.scss
// module id = ./src/app/master/master-register-profile/master-register-profile.component.scss
// module chunks = main